import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from 'react-select';
import autocompleteItem from 'components/snippets/autocompleteItem';
import autocompleteMenu from 'components/snippets/autocompleteMenu';
import autocompleteMenuList from 'components/snippets/autocompleteMenuList';

const Select = (props) => {
    const {
        onSelect,
        onVisibilityChange,
        value,
        id,
        placeholder,
        options,
    } = props;

    const filter = (item, filterValue) => {
        const filterText = filterValue.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
        const regexFilter = new RegExp(filterText, 'i');
        return regexFilter.test(item.label);
    };

    const onChange = (item, action) => {
        if (action.action === 'select-option') {
            onSelect(item);
        }
    };

    const onBlur = () => {
        onVisibilityChange(false);
    };

    const styles = {
        menu: () => ({}),
        menuList: () => ({}),
        option: () => ({
            padding: '10px 15px',
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0px',
            margin: '0px',
            backgroundColor: '#eaecec',
            borderRadius: '8px',
        }),
        control: (provided) => ({
            ...provided,
            borderRadius: '0.3rem',
            border: '0',
        }),
        input: (provided) => ({
            ...provided,
            padding: '0px',
            margin: '0px',
            border: 0,
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            display: 'none',
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            display: 'none',
        }),
    };

    return (
        <Autocomplete
            inputId={id}
            options={options}
            value={value}
            styles={styles}
            components={{ Option: autocompleteItem, Menu: autocompleteMenu, MenuList: autocompleteMenuList }}
            placeholder={placeholder}
            onBlur={onBlur}
            filterOption={filter}
            isSearchable={false}
            getOptionLabel={(option) => option.text}
            onChange={onChange}
        />
    );
};

Select.propTypes = {
    placeholder: PropTypes.string,
    id: PropTypes.string,
    onVisibilityChange: PropTypes.func,
    value: PropTypes.instanceOf(Object),
    onSelect: PropTypes.func.isRequired,
    options: PropTypes.instanceOf(Array).isRequired,
};

Select.defaultProps = {
    onVisibilityChange: () => {},
    id: '',
    placeholder: 'Select option',
    value: null,
};

export default Select;
